function isFile(value) {
  return typeof File !== 'undefined' && value instanceof File;
}

function appendValue(formData, key, value) {
  if (value === undefined || value === null) {
    return;
  }

  if (Array.isArray(value)) {
    value.forEach((item, index) => appendValue(formData, `${key}[${index}]`, item));
    return;
  }

  if (isFile(value)) {
    formData.append(key, value);
    return;
  }

  if (typeof value === 'object') {
    Object.keys(value).forEach(childKey => {
      appendValue(formData, `${key}[${childKey}]`, value[childKey]);
    });
    return;
  }

  formData.append(key, value);
}

export function toFormData(payload = {}) {
  const formData = new FormData();

  Object.keys(payload).forEach(key => {
    appendValue(formData, key, payload[key]);
  });

  return formData;
}
